module.exports = __webpack_public_path__ + "static/case2_allergy_mobile-05b39a3872299bc186dc3fe02b5ca373.png";